<div class="login-container">
    <form class="card" [formGroup]="loginForm">
        <div class="logo-container mb-6">
            <img class="logo" src="assets/logos/sewio_full.png" />
        </div>
        <div class="welcome-container mb-4">Welcome</div>
        <div class="message-container mb-4">Log in to Sewio Networks s.r.o. to continue to myRTLS (On-Prem).</div>
        <mat-form-field class="mb-2" appearance="fill" [hideRequiredMarker]="true">
            <mat-label>Email address</mat-label>
            <input type="email" matInput name="reset-password-email" formControlName="email" />
            @if (loginForm.controls['email'].hasError('required')) {
                <mat-error> Not a valid email address. </mat-error>
            } @else {
                @if (loginForm.controls['email'].hasError('email')) {
                    <mat-error> Not a valid email address. </mat-error>
                }
            }
        </mat-form-field>
        <mat-form-field class="mb-2" appearance="fill" [hideRequiredMarker]="true">
            <mat-label>Password</mat-label>
            <input [type]="hidePassword ? 'password' : 'text'" matInput formControlName="password" />
            <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hidePassword = !hidePassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hidePassword"
            >
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (loginForm.controls['password'].hasError('required')) {
                <mat-error> Password is required. </mat-error>
            }
        </mat-form-field>
        <div class="forgot-container mb-4">
            @if ((smtpStatus$ | async)?.enabled) {
                <a href="#" (click)="redirectToPasswordReset($event)">Forgot password?</a>
            } @else {
                <span class="text-sm text-gray-400 cursor-default" title="SMTP server is not configured.">Forgot password?</span>
            }
        </div>
        <button mat-flat-button color="primary" type="submit" [disabled]="loginForm.invalid && loginForm.touched" (click)="login()">Continue</button>
    </form>
</div>
